import styled from "styled-components";

export const MapMobileWrapper = styled.div`
.react-multiple-carousel__arrow--right,.react-multiple-carousel__arrow--left {
    z-index:0;
}
`;